/**
 * Tooltips dictionary for financial terms
 * Used across the advisor panel for user education
 */

export const TOOLTIPS = {
  // Oprocentowanie
  rrso: "Rzeczywista Roczna Stopa Oprocentowania - uwzględnia wszystkie koszty kredytu: oprocentowanie, prowizję, ubezpieczenia. Pozwala porównać rzeczywisty koszt różnych ofert.",

  interestRate:
    "Nominalna stopa procentowa - oprocentowanie kredytu bez dodatkowych kosztów. Dla kredytów hipotecznych zwykle składa się z marży banku + WIBOR.",

  margin:
    "Marża banku - stała część oprocentowania dodawana do stopy referencyjnej (np. WIBOR). Im niższa marża, tym tańszy kredyt.",

  wibor:
    "Warsaw Interbank Offered Rate - stopa procentowa po jakiej banki pożyczają sobie pieniądze. Wpływa na wysokość raty kredytów ze zmiennym oprocentowaniem.",

  // Koszty
  commission:
    "Prowizja - jednorazowa opłata pobierana przy uruchomieniu kredytu, wyrażona jako procent kwoty kredytu.",

  monthlyPayment:
    "Rata miesięczna - kwota do spłaty co miesiąc, obejmująca część kapitałową i odsetkową kredytu.",

  // Kredyt hipoteczny
  ltv: "Loan To Value - stosunek kwoty kredytu do wartości nieruchomości. Np. LTV 80% oznacza, że kredyt pokrywa 80% wartości mieszkania.",

  wklad:
    "Wkład własny - część wartości nieruchomości, którą musisz pokryć z własnych środków. Minimum to zazwyczaj 10-20%.",

  // Zdolność kredytowa
  dti: "Debt To Income - stosunek wszystkich zobowiązań do dochodu. Banki zazwyczaj akceptują DTI do 50-60%.",

  creditworthiness:
    "Zdolność kredytowa - maksymalna kwota kredytu, jaką bank może Ci udzielić na podstawie Twoich dochodów i zobowiązań.",

  // Typy kredytów
  hipoteczny:
    "Kredyt hipoteczny - długoterminowy kredyt zabezpieczony hipoteką na nieruchomości. Najniższe oprocentowanie, długi okres spłaty (do 35 lat).",

  gotowkowy:
    "Kredyt gotówkowy - kredyt bez zabezpieczenia na dowolny cel. Szybka decyzja, krótszy okres spłaty (do 10 lat), wyższe oprocentowanie.",

  konsolidacyjny:
    "Kredyt konsolidacyjny - łączy kilka kredytów w jeden z niższą ratą. Upraszcza spłatę i może obniżyć miesięczne koszty.",

  // Oprocentowanie
  rateFixed:
    "Oprocentowanie stałe - rata nie zmienia się przez określony czas (np. 5 lat). Daje pewność co do wysokości raty.",

  rateVariable:
    "Oprocentowanie zmienne - rata może się zmieniać wraz ze zmianą stóp procentowych (WIBOR). Może być tańsze, ale niesie ryzyko wzrostu raty.",

  // Okres kredytu
  period:
    "Okres kredytowania - czas na spłatę kredytu w miesiącach. Dłuższy okres = niższa rata, ale wyższy całkowity koszt.",

  // Kwota
  amount:
    "Kwota kredytu - suma pieniędzy, którą pożyczasz od banku. Nie obejmuje dodatkowych kosztów jak prowizja czy ubezpieczenie.",

  // Inne
  internalNotes:
    "Notatki wewnętrzne - widoczne tylko dla Ciebie, nie są pokazywane klientowi. Możesz tu zapisać uwagi dotyczące negocjacji lub warunków.",

  clientNotes:
    "Uwagi dla klienta - te informacje będą widoczne dla klienta w jego panelu ofert.",
} as const;

export type TooltipKey = keyof typeof TOOLTIPS;

/**
 * Get tooltip content by key, with fallback
 */
export function getTooltip(key: string): string | undefined {
  return TOOLTIPS[key as TooltipKey];
}
